import api from '../../../utils/api';

/**
 * Deer seasons a club has hunts in. The backend owns the rollover rule and
 * which season to preselect, so the client never computes season dates.
 */
export async function fetchClubSeasons(clubId) {
  const res = await api.get(`/clubs/${clubId}/seasons/`);
  return res?.data || null;
}

/** `?season=2026-2027`, or empty when no season is selected. */
export function seasonQuery(season) {
  return season ? `?${new URLSearchParams({ season }).toString()}` : '';
}

/** Query string for the paginated club hunt log. */
export function huntsQuery(limit, offset, season) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (season) params.set('season', season);
  return `?${params.toString()}`;
}
